import _ from "lodash";
import { useMemo } from "react";
import { useLeaseCompStore } from "..";
import useLeaseCompsWithFocusArea from "./useLeaseCompsWithFocusArea";
import useLeaseCompsWithGlobalFilters from "./useLeaseCompsWithGlobalFilters";

export default function () {
    const leaseCompStore = useLeaseCompStore();
    const leaseComps = useLeaseCompsWithFocusArea(useLeaseCompsWithGlobalFilters(leaseCompStore.leaseComps));

    return useMemo(() => {
        const availableOwners = _.sortBy(_.uniq(leaseComps.filter(lc => lc.modifiedByUser).map(lc => lc.modifiedByUser!)));

        return ["All Owners", "None"].concat(availableOwners);
    }, [leaseComps]);
}